import { create } from 'zustand'
import type { IContentType } from '~/@api/generated-api-types-user/Api'
import { persist } from 'zustand/middleware'

// Helper function to convert locale string to language code
export const strToLang = (str: string): string => {
  if (
    str.match(/[a-zA-Z]{2}-[a-zA-Z]{2}/) ||
    str.match(/[a-zA-Z]{2}_[a-zA-Z]{2}/)
  ) {
    return str.substring(0, 2).toLowerCase()
  }
  return str
}

type AppDialogsState = {
  showContentDialog: IContentType | null
  setShowContentDialog: (contentId?: IContentType | null) => void
}

export const useAppDialogsStore = create<AppDialogsState>()(
  persist(
    (set) => ({
      showContentDialog: null,
      setShowContentDialog: (contentId = null) => {
        set({ showContentDialog: contentId })
      },
    }),
    {
      name: 'app-dialogs-store',
    }
  )
)
